import { getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import {toLatin,toCyrill,isLatin,isCyrill} from "~/shared/translate"
export function useTranslate() {
    const {locale,t} = useI18n();
    function translateKey(word:string) {
        if(!word) return 
       try {
        if(locale.value==='uz') {
            if(isLatin(word)) {
                return word
            }
            return toLatin(word)
        } else {
            if(isCyrill(word)) {
                return word
            }
            return toCyrill(word)
        }
    } catch(e) {
           console.error(e)
        return word
       }
    }

    return {
        translateKey,locale,t,toLatin,toCyrill
    }
}